import React from "react";
import { NavBar } from "./NavBar";
interface Props {
  header?: React.ReactNode;
  children: React.ReactNode;
}
export function SingleMiddleColumnLayout({
  header,
  children
}: Props) {
  return <div className="flex-1 w-full flex flex-col gap-10 items-center" data-sentry-component="SingleMiddleColumnLayout" data-sentry-source-file="layouts.tsx">
      <NavBar data-sentry-element="NavBar" data-sentry-source-file="layouts.tsx">
        {header && <div className="absolute left-1/2 transform -translate-x-1/2 text-center max-w-md w-full px-4 sm:px-0">
            {header}
          </div>}
      </NavBar>
      <div className="flex-1 flex flex-col gap-10 w-full px-3 mb-10">
        <main className="flex flex-col items-center px-4 md:px-6">
          <div className="w-full max-w-md space-y-6">{children}</div>
        </main>
      </div>
    </div>;
}